import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseSupplierProduct() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      companyName: isEmpty(state.companyName),
      visitorName: isEmpty(state.visitorName),
      visitorMobile: isEmpty(state.visitorMobile),
    };

    setter(errorState);

    if (
      errorState.companyName ||
      errorState.visitorName ||
      errorState.visitorMobile
    ) {
      enqueueSnackbar("لطفا اطلاعات محصول تامین کننده را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getSupplierProductList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_SupplierProducts?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllSupplierProductList = (callback) => {
    MyAxios.get(`Admin_SupplierProducts?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getSupplierByID = (id, callback) => {
    MyAxios.get(`Admin_SupplierProducts/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getSupplierProductsByID = (id, myPC, callback) => {
    MyAxios.get(`Admin_SupplierProducts/Products/${id}`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getSupplierBrandsByID = (id, myPC, callback) => {
    MyAxios.get(`Admin_SupplierProducts/Brands/${id}`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateSupplierProduct = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_SupplierProducts`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محصول تامین کننده با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addSupplierProduct = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_SupplierProducts`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محصول تامین کننده با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteSupplierBrand = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_SupplierProducts/Brand`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("برند با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const deleteSupplierProduct = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_SupplierProducts/Product`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("محصول با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    getSupplierProductList,
    getAllSupplierProductList,
    validate,
    updateSupplierProduct,
    addSupplierProduct,
    deleteSupplierBrand,
    deleteSupplierProduct,
    getSupplierProductsByID,
    getSupplierBrandsByID,
    getSupplierByID,
  };
}
